import Vue from 'vue'
import VueHead from 'vue-head'

import './plugins/axios'
import './plugins/axioslicense'

Vue.use(VueHead)


import IndexRouter from './router';

/* Bootstrap */
import { BootstrapVue, IconsPlugin, TabsPlugin } from 'bootstrap-vue'
import VueGtag from "vue-gtag";

// Import Bootstrap an BootstrapVue CSS files (order is important)
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(TabsPlugin)

/* Clipboard */
import Clipboard from 'v-clipboard'

Vue.use(Clipboard)

import App from './App.vue'


/* font awesome */
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import { faStopwatch, faLaptopCode } from '@fortawesome/pro-regular-svg-icons';
import { faHardHat, faSearch } from '@fortawesome/pro-light-svg-icons';
import { faRocketLaunch, faLock, faSitemap } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faPlayCircle, faRocketLaunch, faLock, faHardHat, faStopwatch, faLaptopCode, faSearch, faSitemap, faLinkedin);

Vue.component('font-awesome-icon', FontAwesomeIcon);


import './assets/sass/master.scss';

Vue.config.productionTip = false



const UA_ACCOUNT = process.env.VUE_APP_UA_ACCOUNT;

Vue.use(VueGtag, {
  config: {
    id: UA_ACCOUNT,
    params: {
      send_page_view: true,
      // linker: {
      //   domains: ['skippr.io', 'www.skippr.io', 'console.skippr.io', 'docs.skippr.io'],
      //   accept_incoming: true,
      //   url_tag: 'skippr',
      //   decorate_forms: true,
      //   conversion_linker: true,
      //   conversion_cookie_prefix: '_skippr_',
      //   ignore_referrer: false,
      // }
    }
  },
  appName: 'Skippr',
  enabled: true,
  // bootstrap: true,
  // onReady: null,
  // onError: null,
  // onBeforeTrack: null,
  // onAfterTrack: null,
  // customResourceURL: "https://www.googletagmanager.com/gtag/js",
  // customPreconnectOrigin: "https://www.googletagmanager.com",
  // deferScriptLoad: false,
  // pageTrackerTemplate: null,
  // pageTrackerExcludedRoutes: [],
  pageTrackerEnabled: true,
  pageTrackerScreenviewEnabled: true,
  pageTrackerUseFullPath: true,
  pageTrackerPrependBase: true,
  pageTrackerSkipSamePath: true,
  // disableScriptLoad: false,
  // globalDataLayerName: "dataLayer",
  // globalObjectName: "gtag",
  // defaultGroupName: "default",
  // includes: null,
}, IndexRouter);


new Vue({
      router: IndexRouter,
      render: h => h(App),
  methods: {
    selecionarUsuario(usuario){
      this.$emit('usuarioSelecionado', usuario)
    },
    quandoSelecionarUsuario(callback){
      this.$on('usuarioSelecionado', callback)
    }
  },
  head: {
    title: {
      inner: 'Skippr',
      separator: '-',
      complement: 'Data Integration and Preparation'
    },
    // Meta tags
    meta: [
      {name: 'application-name', content: 'Skippr'},
      {
        name: 'description',
        content: 'Connect any data source to any cloud data warehouse, datalake and streaming service',
      },

      // favicons
      {name: 'apple-mobile-web-app-title', content: 'Skippr'},
      {name: 'application-name', content: 'Skippr'},
      {name: 'msapplication-TileColor', content: '#2d89ef'},
      {name: 'theme-color', content: '#ffffff'},

      // Twitter
      {name: 'twitter:title', content: 'Skippr'},
      // with shorthand
      {
        n: 'twitter:description',
        c: 'Connect any data source to any cloud data warehouse, datalake and streaming service'
      },
      // ...
      // Google+ / Schema.org
      {itemprop: 'name', content: 'Skippr'},
      {
        itemprop: 'description',
        content: 'Connect any data source to any cloud data warehouse, datalake and streaming service'
      },
      // ...
      // // Facebook / Open Graph
      // { property: 'fb:app_id', content: '123456789' },
      // { property: 'og:title', content: 'Content Title' },
      // // with shorthand
      // { p: 'og:image', c: 'https://example.com/image.jpg' },
      // ...
    ],
    // link tags
    link: [
      {rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png'},
      {rel: 'icon', type: 'image/png', href: '/favicon-32x32.png'},
      {rel: 'icon', type: 'image/png', href: '/favicon-16x16.png'},
      {rel: 'manifest', href: '/site.webmanifest'},
      {rel: 'mask-icon', color: '#5bbad5', href: '/safari-pinned-tab.svg'},

      // { rel: 'canonical', href: 'http://example.com/#!/contact/', id: 'canonical' },
      // { rel: 'author', href: 'author', undo: false }, // undo property - not to remove the element
      // { rel: 'icon', href: require('./path/to/icon-16.png'), sizes: '16x16', type: 'image/png' },
      // // with shorthand
      // { r: 'icon', h: 'path/to/icon-32.png', sz: '32x32', t: 'image/png' },
      // ...
    ],


    script: [
      { type: 'text/javascript', src: '//js.hs-scripts.com/7937467.js', async: true, defer: true, body: true}, // HubSpot
      // { type: "text/javascript",  inner: 'adroll_adv_id = "YLGVFLOBEBDHJBD32UHU3U"; adroll_pix_id = "MAD5TFXFRJCMFME5S2AJIC"; adroll_version = "2.0";  (function(w, d, e, o, a) { w.__adroll_loaded = true; w.adroll = w.adroll || []; w.adroll.f = [ \'setProperties\', \'identify\', \'track\' ]; var roundtripUrl = "https://s.adroll.com/j/" + adroll_adv_id + "/roundtrip.js"; for (a = 0; a < w.adroll.f.length; a++) { w.adroll[w.adroll.f[a]] = w.adroll[w.adroll.f[a]] || (function(n) { return function() { w.adroll.push([ n, arguments ]) } })(w.adroll.f[a]) }  e = d.createElement(\'script\'); o = d.getElementsByTagName(\'script\')[0]; e.async = 1; e.src = roundtripUrl; o.parentNode.insertBefore(e, o); })(window, document); adroll.track("pageView");'},
      //   { type: 'text/javascript', src: 'cdn/to/script.js', async: true, body: true}, // Insert in body
      //   // with shorthand
      //   { t: 'application/ld+json', i: '{ "@context": "http://schema.org" }' },
      //   // ...
    ],
    // style: [
    //   { type: 'text/css', inner: 'body { background-color: #000; color: #fff}', undo: false },
    //   // ...
    // ]
  }
}).$mount('#app')

